import { render } from "./DeveloperItemSwitch.vue?vue&type=template&id=532caa80"
import script from "./DeveloperItemSwitch.vue?vue&type=script&lang=js"
export * from "./DeveloperItemSwitch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__